import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { PendingChecklistsQueryKeys } from "modules/PendingChecklistsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { InterventionKeywordPendingChecklist } from "models";

export const useReorderInterventionPendingChecklistsMutation = () =>
  useTypedMutation<InterventionKeywordPendingChecklist[], void>({
    mutationFn: async intervention_keyword_pending_checklists =>
      (await ApiInstance.post("/intervention_keywords_pending_checklists/reorder", { intervention_keyword_pending_checklists }, ENV.dealerBaseURL)).data,
    onSuccess: reorderedChecklists => {
      const pendingChecklists = typedQueryClient.getQueryData(PendingChecklistsQueryKeys.interventionPendingChecklists);
      if (!pendingChecklists?.length || !reorderedChecklists.length) return;

      const checklistsThatAreNotReordered = pendingChecklists.filter(p => p.keyword !== reorderedChecklists[0].keyword);
      typedQueryClient.setQueryData(PendingChecklistsQueryKeys.interventionPendingChecklists, [...checklistsThatAreNotReordered, ...reorderedChecklists]);
    }
  });
